module.exports = __webpack_public_path__ + "static/demo-e2888e7ef7ea4181130b5b79f02097ab.gif";